import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead'
import { MercadoFilterModule } from '../filter';
import { MercadoSituacaoModule } from '../situacao';

import { MercadoTypeaheadComponent } from './mercado-typeahead.component';

@NgModule({
    imports: [
        SharedModule,
        TypeaheadModule,
        MercadoFilterModule,
        MercadoSituacaoModule
    ],
    declarations: [
        MercadoTypeaheadComponent
    ],
    exports: [
        MercadoTypeaheadComponent
    ]
})
export class MercadoTypeaheadModule { }
